<template>
  <div>
    <div v-if="anschluss">
      {{ $t('fahrdienst452.type') }}: {{ anschluss.art }} {{ $t('fahrdienst452.transferTime') }}: {{ anschluss.umsteigZeit }} {{ $t('fahrdienst452.time') }}:
      {{ getTime().toLocaleTimeString() }}
    </div>
    <div v-else></div>
  </div>
</template>

<script>
export default {
  name: 'Anschluss',
  props: {
    anschluss: { type: Object },

    fahrtDateAsTime: { type: Number },
  },
  methods: {
    getTime() {
      // console.debug(`getTime this.fahrtDateAsTime=${this.fahrtDateAsTime} this.anschluss.minutesafterMidnight=${this.anschluss.minutesafterMidnight}`);
      try {
        let d = new Date(this.fahrtDateAsTime);
        d.setMinutes(this.anschluss.minutesafterMidnight);
        return d;
      } catch (err) {
        return 'na';
      }
    },
  },
};
</script>
